export default class Request {
  static sendRequest(subConfig) {
    const config = subConfig;
    config.baseURL = process.env.VUE_APP_BASE_URL;
    config.headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      // 'Authorization': `Bearer ${localStorage.getItem('jwt')}`,
      // 'language': localStorage.getItem('lang'),
    };
    return new Promise((resolve, reject) => {
      axios.request(config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  }

  static get(url, params) {
    const config = {
      method: 'get',
      url,
      params,
    };
    return this.sendRequest(config);
  }

  static post(url, data) {
    const config = {
      method: 'post',
      url,
      data,
    };
    return this.sendRequest(config);
  }

  static put(url, data) {
    const config = {
      method: 'put',
      url,
      data,
    };
    return this.sendRequest(config);
  }

  static delete(url, params) {
    const config = {
      method: 'delete',
      url,
      params,
    };
    return this.sendRequest(config);
  }
}
